export function selectMyExampleOfPaymentInformation(queryParams) {
  return this.get(
    `/zntop/orderForMemberController/selectMyExampleOfPaymentInformation`,
    { params: queryParams }
  );
}
export function selectAccount(queryParams) {
  return this.get(`/zntop/MemberCenter/selectAccount`, { params: queryParams });
}

export function selectCompanyList(queryParams) {
  return this.get(`/zntop/MemberCenter/selectCompanyList`, {
    params: queryParams,
  });
}

export function weChatPayordering(queryParams) {
  return this.get(`/znsystem/weixin/weChatPayordering`, {
    params: queryParams,
  });
}
export function getConsumerDetails(queryParams) {
  return this.post(`/znsystem/membercen/getConsumerDetails`, queryParams);
}

export function getSection(queryParams) {
  return this.get(`/zntop/top/getSection`, { params: queryParams });
}
export function getDictionary(queryParams) {
  return this.get(`/zntop/top/getDictionary`, { params: queryParams });
}
export function updateAmount(queryParams) {
  return this.get(`/zntop/MemberCenter/updateAmount`, { params: queryParams });
}
export function getTitle(queryParams) {
  return this.get(`/zntop/top/getTitle`, { params: queryParams });
}
export function getUserInfo(queryParams) {
  return this.get(`/znsystem/weixin/getUserInfo`, { params: queryParams });
}

export function getUserfunusenum(queryParams) {
  return this.get(`/znsystem/weixin/getUserfunusenum`, { params: queryParams });
}
export function getDevelop(queryParams) {
  return this.get(`/zntop/top/getDevelop`, { params: queryParams });
}
export function weChatPayconfirm(queryParams) {
  return this.get(`/znsystem/weixin/weChatPayconfirm`, { params: queryParams });
}
export function weChatPayStausQuery(queryParams) {
  return this.get(`/znsystem/weixin/weChatPayStausQuery`, { params: queryParams });
}



export function login(queryParams) {
  return this.post(`/znauth/login`, queryParams);
}

export function refresh(queryParams) {
  return this.post(`/znauth/refresh`, queryParams);
}
export function register(queryParams) {
  return this.post(`/znauth/register`, queryParams);
}
export function weChatloginnumber(queryParams) {
  return this.get(`/znsystem/weixin/weChatloginnumber`, {
    params: queryParams,
  });
}
export function getDevelopShow(queryParams) {
  return this.post(`/zntop/top/getDevelopShow`, queryParams);
}
export function insertRecordAccess(queryParams) {
  return this.post(`/znsystem/thirdparty/insertRecordAccess`, queryParams);
}



export function vxcallback(queryParams) {
  return this.get(`/znsystem/weixin/vxcallback`, { params: queryParams });
}
export function getInformation(queryParams) {
  return this.get(`/zntop/top/getInformation`, { params: queryParams });
}
export function deleteCompany(queryParams) {
  return this.get(`/zntop/MemberCenter/deleteCompany`, { params: queryParams });
}

export function insertOrderForInvoiceApplication(queryParams) {
  return this.post(
    `/zntop/orderForMemberController/insertOrderForInvoiceApplication`,
    queryParams
  );
}
export function insertMyPaymentVoInfo(queryParams) {
  return this.post(
    `/zntop/orderForMemberController/insertMyPaymentVoInfo`,
    queryParams
  );
}

export function selectOrderCompanyInfo(queryParams) {
  return this.get(`/zntop/orderForMemberController/selectOrderCompanyInfo`, {
    params: queryParams,
  });
}
export function insertOrderCompanyInfo(queryParams) {
  return this.post(
    `/zntop/orderForMemberController/insertOrderCompanyInfo`,
    queryParams
  );
}

export function insertMyOrderVoInfo(queryParams) {
  return this.post(
    `/zntop/orderForMemberController/insertMyOrderVoInfo`,
    queryParams
  );
}
export function selectMyPaymentVoInfo(queryParams) {
  return this.post(
    `/zntop/orderForMemberController/selectMyPaymentVoInfo`,
    queryParams
  );
}


export function deleteOrderFor(queryParams) {
  return this.get(`/zntop/orderForMemberController/deleteOrderFor`, {
    params: queryParams,
  });
}

export function getEmail(queryParams) {
  return this.get(`/zntop/top/getEmail`, {
    params: queryParams,
  });
}

export function insertCompany(queryParams) {
  return this.post(
    `/zntop/MemberCenter/insertCompany`,
    queryParams
  );
}

export function updateUserInfo(queryParams) {
  return this.put(
    `/znsystem/weixin/updateUserInfo`,
    queryParams
  );
}
export function getSubscriber(queryParams) {
  return this.get(`/zntop/top/getSubscriber`, {
    params: queryParams,
  });
}

export function getAreaCity(queryParams) {
  return this.get(`/zntop/top/getAreaCity`, {
    params: queryParams,
  });
}



export function getOrderFor(queryParams) {
  return this.get(`/zntop/orderForMemberController/getOrderFor`, {
    params: queryParams,
  });
}
export function addSubscriber(queryParams) {
  return this.post(
    `/zntop/top/addSubscriber`,
    queryParams
  );
}


export function getMemberList(queryParams) {
  return this.get(`/zntop/MemberCenter/getMemberList`, {
    params: queryParams,
  });
}
export function deleteSubscriber(queryParams) {
  return this.delete(`/zntop/top/deleteSubscriber`, {
    params: queryParams,
  });
}

export function updatePwd(queryParams) {
  return this.put(
    `/znsystem/user/profile/updatePwd`,
    queryParams
  );
}

export function getSubscriberPageInfo(queryParams) {
  return this.post(
    `/zntop/top/getSubscriberPageInfo`,
    queryParams
  );
}
export function upDateUserfunusenum(queryParams) {
  return this.post(
    `/znsystem/weixin/upDateUserfunusenum`,
    queryParams
  );
}
 export function  getAreaProvince(queryParams) {
  return this.get(`/zntop/top/getAreaProvince`, {
    params: queryParams,
  });
}
 export function  getSectionShow(queryParams) {
  return this.post(`/zntop/top/getSectionShow`, 
     queryParams,
  );
}


export function insertInvoiceInfo(queryParams) {
  return this.post(
    `/zntop/orderForMemberController/insertInvoiceInfo  `,
    queryParams
  );
}

export function getFinancing(queryParams) {
  return this.post(
    `/zntop/top/getFinancing  `,
    queryParams
  );
}

export function getInvoiceInfo(queryParams) {
  return this.get(`/zntop/orderForMemberController/getInvoiceInfo`, {
    params: queryParams,
  });
}
export function getDataProduct(queryParams) {
  return this.post(`/zntop/top/getDataProduct`, 
    queryParams,
  );
}

export function getBrowse(queryParams) {
  return this.post(`/zntop/top/getBrowse`, 
    queryParams,
  );
}
export function updateHotWord(queryParams) {
  return this.get(`/zntop/top/updateHotWord`, 
    {    params: queryParams,}
  );
}

export function updateShowNum(queryParams) {
  return this.get(`/zntop/top/updateShowNum`, 
    {    params: queryParams,}
  );
}

export function getPersona(queryParams) {
  return this.post(`/zntop/top/getPersona
`, 
    queryParams,
  );
}



